<template>
    <v-row v-if="!$store.getters.progress" class="pb-offset ma-0">
        <v-col class="pa-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-3">Gestione Approvvigionamenti</p>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="$eventBusUtility.exportCSV(headers, items, 'Approvvigionamenti')" v-on="on" icon>
                                <v-icon>mdi-download</v-icon>
                            </v-btn>
                        </template>
                        <span>Download CSV</span>
                    </v-tooltip>
                </v-card-title>
                <v-divider></v-divider>

                <v-alert
                    text
                    dense
                    type="info"
                    class="ma-4 mb-0"
                    icon="mdi-information-outline">
                    <span class="body-2">
                        Questa schermata consente di gestire gli approvvigionamenti visualizzando i prodotti da ordinare
                        ai fornitori basandosi sugli ordini di vendita. Puoi calcolare le quantità rimanenti da ordinare,
                        selezionare i prodotti e generare automaticamente gli ordini di acquisto tracciando lo stato
                        di approvvigionamento di ogni articolo.
                        <strong>Gli ordini di acquisto vengono raggruppati per fornitore e progetto:</strong>
                        prodotti con stesso fornitore e stesso progetto saranno inclusi in un unico ordine di acquisto,
                        altrimenti verranno generati ordini separati.
                    </span>
                </v-alert>

                <v-container fluid :class="{'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                    <fields-generator
                        v-if="Object.keys(fieldsset).length > 0"
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                    ></fields-generator>

                    <v-divider class="mt-4"></v-divider>

                    <v-data-table
                        :items="items"
                        :headers="headers"
                        :loading="loading"
                        v-model="selected"
                        show-select
                        show-expand
                        :expanded.sync="expanded"
                        item-key="id"
                        :server-items-length="totalItems"
                        :page.sync="page"
                        :items-per-page.sync="perPage"
                        @update:page="onPageChange"
                        @update:items-per-page="onItemsPerPageChange"
                        @item-expanded="onItemExpanded"
                        :footer-props="{
                            'items-per-page-options': [10, 25, 50, 100,  { text: 'Tutti', value: -1 }],
                            showFirstLastPage: true
                        }"
                        fixed-header
                        class="background-2 enhanced-table"
                        :mobile-breakpoint="0"
                        ref="supplyTable">

                        <template v-slot:header.data-table-select="{ on, props }">
                            <v-simple-checkbox color="primary" v-bind="props" v-on="on"></v-simple-checkbox>
                        </template>

                        <template v-slot:no-data>
                            <v-container v-if="!loading" class="text-center py-8">
                                <v-icon size="64">mdi-package-variant</v-icon>
                                <h3 class="mt-4">Nessun prodotto da ordinare</h3>
                                <p>Modifica i filtri per visualizzare i prodotti da approvvigionare</p>
                            </v-container>
                            <v-container v-else class="text-center py-8">
                                <v-icon size="64">mdi-magnify-close</v-icon>
                                <h3 class="mt-4">Nessun risultato trovato</h3>
                                <p>Prova a modificare i criteri di ricerca</p>
                            </v-container>
                        </template>

                        <template v-slot:no-results>
                            <v-container v-if="!loading" class="text-center py-8">
                                <v-icon size="64">mdi-magnify-close</v-icon>
                                <h3 class="mt-4">Nessun risultato trovato</h3>
                                <p>Prova a modificare i criteri di ricerca</p>
                            </v-container>
                        </template>

                        <template v-slot:item="{item, select, isSelected, headers, index, expand, isExpanded}">
                            <tr class="cursor-pointer">
                                <template v-for="(header, h) in headers">
                                    <td :key="'expand-'+h" v-if="header.value == 'data-table-expand'">
                                        <v-icon @click="expand(!isExpanded)">
                                            {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                        </v-icon>
                                    </td>
                                    <td :key="'select-'+h" v-else-if="header.value == 'data-table-select'">
                                        <v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                                    </td>
                                    <td v-else-if="header.type === 'currency'" :key="'currency-'+h">
                                        {{ item[header.value] | currency(2) }}
                                    </td>
                                    <td v-else-if="header.type == 'date'" :key="'date-'+h">
                                        {{ item[header.value] | date }}
                                    </td>
                                    <td v-else-if="header.type == 'number'" :key="'number-'+h">
                                        <v-tooltip top v-if="header.value === 'quantity_to_order'">
                                            <template v-slot:activator="{ on }">
                                                <v-chip
                                                    v-on="on"
                                                    :color="item[header.value] > 0 ? 'error' : 'success'"
                                                    dark
                                                    small
                                                    class="font-weight-bold">
                                                    <v-icon small left>mdi-alert-circle</v-icon>
                                                    {{ item[header.value] }}
                                                </v-chip>
                                            </template>
                                            <span>Quantità da ordinare al fornitore</span>
                                        </v-tooltip>
                                        <v-tooltip top v-else-if="header.value === 'quantity_already_ordered'">
                                            <template v-slot:activator="{ on }">
                                                <v-chip
                                                    v-on="on"
                                                    :color="item[header.value] > 0 ? 'info' : 'grey lighten-2'"
                                                    :dark="item[header.value] > 0"
                                                    small
                                                    class="font-weight-medium">
                                                    <v-icon small left>mdi-cart-check</v-icon>
                                                    {{ item[header.value] }}
                                                </v-chip>
                                            </template>
                                            <span>Quantità già ordinata al fornitore</span>
                                        </v-tooltip>
                                        <v-tooltip top v-else-if="header.value === 'dispatched_quantity'">
                                            <template v-slot:activator="{ on }">
                                                <v-chip
                                                    v-on="on"
                                                    :color="item[header.value] > 0 ? 'success' : 'grey lighten-1'"
                                                    :dark="item[header.value] > 0"
                                                    small
                                                    class="font-weight-medium">
                                                    <v-icon small left>mdi-check-circle</v-icon>
                                                    {{ item[header.value] }}
                                                </v-chip>
                                            </template>
                                            <span>Quantità già evasa/consegnata al cliente</span>
                                        </v-tooltip>
                                        <!-- Giacenza: "-" per i prodotti non movimentati (come la disponibilita'), altrimenti formattata -->
                                        <span v-else-if="header.value === 'stock'" class="font-weight-medium">
                                            {{ item.available_quantity === null ? '-' : formatQuantity(item.stock) }}
                                        </span>
                                        <v-tooltip top v-else-if="header.value === 'available_quantity'">
                                            <template v-slot:activator="{ on }">
                                                <v-chip
                                                    v-on="on"
                                                    :color="item[header.value] > 0 ? 'success' : 'grey lighten-1'"
                                                    :dark="item[header.value] > 0"
                                                    small
                                                    class="font-weight-medium">
                                                    <v-icon small left>mdi-warehouse</v-icon>
                                                    {{ item[header.value] === null ? '-' : formatQuantity(item[header.value]) }}
                                                </v-chip>
                                            </template>
                                            <span v-if="item[header.value] === null">Prodotto non movimentato a magazzino</span>
                                            <span v-else>Disponibile al netto degli altri ordini aperti (giacenza {{ formatQuantity(item.stock) }})</span>
                                        </v-tooltip>
                                        <v-tooltip top v-else-if="header.value === 'quantity'">
                                            <template v-slot:activator="{ on }">
                                                <v-chip
                                                    v-on="on"
                                                    color="grey darken-1"
                                                    dark
                                                    small
                                                    class="font-weight-medium">
                                                    <v-icon small left>mdi-package-variant</v-icon>
                                                    {{ item[header.value] }}
                                                </v-chip>
                                            </template>
                                            <span>Quantità totale ordinata dal cliente</span>
                                        </v-tooltip>
                                        <span v-else :class="header.class || 'font-weight-medium'">
                                            {{ item[header.value] }}
                                        </span>
                                    </td>
                                    <td v-else-if="header.type == 'purchase_price_editable'" style="min-width: 130px; max-width: 150px;" :key="'price-'+h">
                                        <v-text-field
                                            :disabled="!isSelected"
                                            label="Prezzo"
                                            v-model="item['purchase_price']"
                                            type="number"
                                            step="0.01"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </td>
                                    <td v-else-if="header.type == 'supplier_select'" style="min-width: 250px; max-width: 400px;" :key="'supplier-'+h">
                                        <v-autocomplete
                                            autocomplete="no"
                                            :disabled="!isSelected"
                                            label="Fornitore"
                                            :items="item.suppliers"
                                            v-model="item['supplier_id']"
                                            :menu-props="{maxHeight:'200'}"
                                            :return-object="false"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                            v-validate="!isSelected ? '' : 'required'"
                                            :error-messages="errors.collect('Fornitore'+item.id)"
                                            data-vv-as="Fornitore"
                                            :data-vv-name="'Fornitore'+item.id"
                                            @change="onSupplierChange(item, $event)">
                                            <template v-slot:item="data">
                                                <template>
                                                    <v-list-item-avatar
                                                        size="32px"
                                                        style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
                                                        class="primary mr-4">
                                                        <v-icon class="fs18i" color="white">mdi-store</v-icon>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            <span>{{ data.item.subtitle }}</span>
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </template>
                                            </template>
                                        </v-autocomplete>
                                    </td>
                                    <td v-else-if="header.type == 'quantity_editable'" style="min-width: 130px; max-width: 150px;" :key="'quantity-'+h">
                                        <v-text-field
                                            :disabled="!isSelected"
                                            label="Quantità"
                                            v-model="item['quantity_to_order_supplier']"
                                            type="number"
                                            step="0.01"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                            v-validate="!isSelected ? '' : 'required|min_value:0.01'"
                                            :error-messages="errors.collect('Quantità'+item.id)"
                                            data-vv-as="Quantità"
                                            :data-vv-name="'Quantità'+item.id"
                                        ></v-text-field>
                                    </td>
                                    <td v-else :key="'default-'+h" :class="header.class">
                                        {{ item[header.value] }}
                                    </td>
                                </template>
                            </tr>
                        </template>

                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="pa-0 background-1" style="padding: 0 !important;">
                                <v-container fluid class="background-1 pa-4">
                                    <v-row v-if="loadingDetails[item.product_saleorder_id]">
                                        <v-col cols="12" class="text-center">
                                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                        </v-col>
                                    </v-row>

                                    <v-row v-else-if="productDetails[item.product_saleorder_id]">
                                        <!-- Ordini di Acquisto e DDT Acquisto -->
                                        <v-col cols="12" md="6">
                                            <!-- Ordini di Acquisto -->
                                            <v-card class="mb-4 round-card pb-2 background-2">
                                                <v-card-title class="subtitle-1 primary py-2">
                                                    <v-icon left>mdi-cart</v-icon>
                                                    Ordini di Acquisto Collegati
                                                </v-card-title>
                                                <v-card-text class="pa-0">
                                                    <v-simple-table dense v-if="productDetails[item.product_saleorder_id].purchaseorders.length > 0">
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th>N. Ordine</th>
                                                                    <th>Data</th>
                                                                    <th>Fornitore</th>
                                                                    <th>Q.tà Allocata</th>
                                                                    <th>Q.tà Ricevuta</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="po in productDetails[item.product_saleorder_id].purchaseorders" :key="po.id"
                                                                    @click="openPurchaseOrder(po.id)"
                                                                    class="cursor-pointer hover-row">
                                                                    <td >
                                                                        <a @click.stop="openPurchaseOrder(po.id)" class="primary--text">
                                                                            {{ po.number }}
                                                                        </a>
                                                                    </td>
                                                                    <td>{{ po.date | date }}</td>
                                                                    <td>{{ po.supplier_name }}</td>
                                                                    <td>{{ po.allocated_quantity }}</td>
                                                                    <td>{{ po.dispatched_quantity }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                    <div v-else class="pa-4 text-center">
                                                        Nessun ordine di acquisto collegato
                                                    </div>
                                                </v-card-text>
                                            </v-card>

                                            <!-- DDT di Acquisto -->
                                            <v-card class="mb-4 round-card pb-2 background-2">
                                                <v-card-title class="subtitle-1 info py-2">
                                                    <v-icon left>mdi-truck-delivery</v-icon>
                                                    DDT di Acquisto Collegati
                                                </v-card-title>
                                                <v-card-text class="pa-0">
                                                    <v-simple-table dense v-if="productDetails[item.product_saleorder_id].purchaseddts && productDetails[item.product_saleorder_id].purchaseddts.length > 0">
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th>N. DDT</th>
                                                                    <th>Data</th>
                                                                    <th>Q.tà Ricevuta</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="pddt in productDetails[item.product_saleorder_id].purchaseddts" :key="pddt.id"
                                                                    @click="openPurchaseddt(pddt.id)"
                                                                    class="cursor-pointer hover-row">
                                                                    <td>
                                                                        <a @click.stop="openPurchaseddt(pddt.id)" class="info--text">
                                                                            {{ pddt.number }}
                                                                        </a>
                                                                    </td>
                                                                    <td>{{ pddt.date | date }}</td>
                                                                    <td>{{ pddt.quantity }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                    <div v-else class="pa-4 text-center">
                                                        Nessun DDT di acquisto collegato
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>

                                        <!-- DDT di Vendita -->
                                        <v-col cols="12" md="6">
                                            <v-card class="mb-4 round-card pb-2 background-2">
                                                <v-card-title class="subtitle-1 success py-2">
                                                    <v-icon left>mdi-truck-delivery</v-icon>
                                                    DDT di Vendita Collegati
                                                </v-card-title>
                                                <v-card-text class="pa-0">
                                                    <v-simple-table dense v-if="productDetails[item.product_saleorder_id].ddts.length > 0">
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th>N. DDT</th>
                                                                    <th>Data</th>
                                                                    <th>Quantità</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="ddt in productDetails[item.product_saleorder_id].ddts" :key="ddt.id"
                                                                    @click="openDdt(ddt.id)"
                                                                    class="cursor-pointer hover-row">
                                                                    <td>
                                                                        <a @click.stop="openDdt(ddt.id)" class="success--text">
                                                                            {{ ddt.number }}
                                                                        </a>
                                                                    </td>
                                                                    <td>{{ ddt.date | date }}</td>
                                                                    <td>{{ ddt.quantity }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                    <div v-else class="pa-4 text-center">
                                                        Nessun DDT di vendita collegato
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </td>
                        </template>
                    </v-data-table>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-4">
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="$store.getters.checkModelPermissions('purchaseorder')"
                            color="primary"
                            :disabled="selected.length === 0"
                            @click="openGeneratePurchaseOrdersDialog">
                            <v-icon left>mdi-cart-plus</v-icon>
                            Genera Ordini di Acquisto ({{ selected.length }})
                        </v-btn>
                    </v-card-actions>
                </v-container>
            </v-card>

            <!-- Dialog Genera Ordini Acquisto -->
            <v-dialog v-model="generateDialog" max-width="600px" persistent>
                <v-card class="background-2 round-card">
                    <v-card-title class="pa-3">
                        <p class="pl-2 pl-xl-3">Genera Ordini di Acquisto</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-4 body-2">Compila i campi per generare gli ordini di acquisto</v-card-text>

                    <v-card-text>
                        <v-container>
                            <fields-generator
                                v-if="Object.keys(generateFieldsset).length > 0"
                                :fieldsset.sync="generateFieldsset"
                                :model="generateModel"
                                ref="generateFieldsgenerator"
                            ></fields-generator>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info" text @click="generateDialog = false">Annulla</v-btn>
                        <v-btn color="primary" @click="generatePurchaseOrders" :loading="generating">Genera</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>

<script>
import FieldsGenerator from '@/components/common/FieldsGenerator'

export default {
    name: 'SupplyManagement',
    components: {
        FieldsGenerator
    },
    data() {
        return {
            fieldsset: {},
            model: {},
            items: [],
            headers: [],
            loading: false,
            search: '',
            selected: [],
            expanded: [],
            productDetails: {},
            loadingDetails: {},
            generateDialog: false,
            generateFieldsset: {},
            generateModel: {},
            generating: false,
            suppliers: [],
            productSupplierPrices: {},
            page: 1,
            perPage: 10,
            totalItems: 0
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        // quantità dal DB come stringhe decimali ("7.00000"): massimo due decimali, formato italiano
        formatQuantity(value) {
            const n = parseFloat(value)
            return isNaN(n) ? value : n.toLocaleString('it-IT', { maximumFractionDigits: 2 })
        },

        async init() {
            try {
                this.$store.commit('startProgress')
                const response = await this.axios.get('supplymanagement-info/')

                this.fieldsset = response.data.fields

                // Inizializza i valori di default
                if (this.fieldsset && this.fieldsset.fields) {
                    this.fieldsset.fields.forEach(field => {
                        if (field.default !== undefined && !this.model[field.key]) {
                            this.$set(this.model, field.key, field.default)
                        }
                    })
                }

                this.headers = response.data.info.fieldDefs.filter(h => {
                    if (h.permissions) {
                        return this.$store.getters.checkModelPermissions(h.permissions.values[0])
                    }
                    return true
                })

                this.$watch('model', () => {
                    this.loadData()
                }, { deep: true })

                await this.loadData()
            } catch (error) {
                console.error('Errore caricamento info:', error)
                this.$store.commit('setSnackbarError')
            } finally {
                this.$store.commit('endProgress')
            }
        },

        async loadData() {
            try {
                this.loading = true
                const payload = {
                    ...this.model,
                    page: this.page,
                    per_page: this.perPage
                }
                const response = await this.axios.post('supplymanagement/', payload)
                this.items = response.data.data
                this.selected = []

                if (response.data.pagination) {
                    this.totalItems = response.data.pagination.total
                }

                if (response.data.suppliers) {
                    this.suppliers = response.data.suppliers
                    this.productSupplierPrices = response.data.product_supplier_prices || {}

                    this.items = this.items.map(item => {
                        item.suppliers = this.suppliers
                        return item
                    })
                }
            } catch (error) {
                console.error('Errore caricamento dati:', error)
                this.$store.commit('setSnackbarError')
            } finally {
                this.loading = false
            }
        },

        onSupplierChange(item, supplierId) {
            if (!supplierId) return

            if (this.productSupplierPrices[item.product_id] && this.productSupplierPrices[item.product_id][supplierId]) {
                item.purchase_price = this.productSupplierPrices[item.product_id][supplierId]
            } else if (item.suppliers) {
                const supplier = item.suppliers.find(s => s.value === supplierId)
                if (supplier && supplier.purchase_price) {
                    item.purchase_price = supplier.purchase_price
                }
            }
        },

        onPageChange(page) {
            this.page = page
            this.loadData()
        },

        onItemsPerPageChange(itemsPerPage) {
            this.perPage = itemsPerPage
            this.page = 1
            this.loadData()
        },

        async openGeneratePurchaseOrdersDialog() {
            const hasErrors = await this.$validator.validateAll()
            if (!hasErrors) {
                this.$store.commit('setSnackbar', {
                    text: 'Completa tutti i campi obbligatori per i prodotti selezionati',
                    value: true,
                    color: 'warning',
                    timeout: 6000
                })
                return
            }

            try {
                const response = await this.axios.get('supplymanagement-generate-purchaseorders-info')
                this.generateFieldsset = response.data.fields
                this.generateModel = {}
                this.generateDialog = true
            } catch (error) {
                console.error('Errore apertura dialog:', error)
                this.$store.commit('setSnackbarError')
            }
        },

        async generatePurchaseOrders() {
            try {
                this.generating = true
                const payload = {
                    ...this.generateModel,
                    orders: this.selected
                }

                await this.axios.post('supplymanagement-generate-purchaseorders', payload)

                this.$store.commit('setSnackbar', {
                    text: 'Ordini di acquisto generati con successo',
                    value: true,
                    color: 'success',
                    timeout: 6000
                })

                this.generateDialog = false
                await this.loadData()
            } catch (error) {
                console.error('Errore generazione ordini:', error)
                this.$store.commit('setSnackbarError')
            } finally {
                this.generating = false
            }
        },

        async onItemExpanded({ item, value }) {
            if (value) {
                // Quando si espande, carica sempre i dati (anche se già esistono)
                this.$set(this.loadingDetails, item.product_saleorder_id, true)

                try {
                    const response = await this.axios.get(`supplymanagement-product-details/${item.product_saleorder_id}`)
                    this.$set(this.productDetails, item.product_saleorder_id, response.data)
                } catch (error) {
                    console.error('Errore caricamento dettagli:', error)
                    this.$store.commit('setSnackbarError')
                } finally {
                    this.$set(this.loadingDetails, item.product_saleorder_id, false)
                }
            } else {
                // Quando si chiude, elimina i dati caricati
                this.$delete(this.productDetails, item.product_saleorder_id)
                this.$delete(this.loadingDetails, item.product_saleorder_id)
            }
        },

        openPurchaseOrder(purchaseorderId) {
            const route = this.$router.resolve({ name: 'purchaseorders-show', params: { id: purchaseorderId } })
            window.open(route.href, '_blank')
        },

        openDdt(ddtId) {
            const route = this.$router.resolve({ name: 'ddts-show', params: { id: ddtId } })
            window.open(route.href, '_blank')
        },

        openPurchaseddt(purchaseddtId) {
            const route = this.$router.resolve({ name: 'purchaseddts-show', params: { id: purchaseddtId } })
            window.open(route.href, '_blank')
        }
    }
}
</script>

<style scoped>
.enhanced-table {
    font-size: 14px
}

.enhanced-table >>> td {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
}

.enhanced-table >>> td:nth-child(2) {
    left: 40px
}

.enhanced-table >>> th:nth-child(2) {
    left: 40px
}

.enhanced-table >>> .v-chip {
    min-width: 70px;
    justify-content: center;
}

/* Reset fixed columns for tables inside expansion panels */
.v-expansion-panel-content >>> td:nth-child(2),
.v-expansion-panel-content >>> th:nth-child(2) {
    left: auto !important;
    position: static !important;
}

.cursor-pointer {
    cursor: pointer
}

.hover-row:hover {
    background-color: rgba(0, 0, 0, 0.04) !important
}
</style>
